var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.listDataLoading,
            expression: "listDataLoading",
          },
        ],
        staticClass: "history-chat",
        style: {
          height:
            _vm.$route.name === "scholarSearchHistoryGuoJiao" ||
            _vm.$route.name === "technicalQAHistoryGuoJiao"
              ? `calc(100vh - 20px)`
              : `calc(100vh - 95px)`,
        },
      },
      [
        _c("div", { staticClass: "chat-title" }, [
          _c("h3", [_vm._v(_vm._s(_vm.chatTitle || "新会话"))]),
          _vm.streamLoading && _vm.searchType === "2"
            ? _c("p", { staticClass: "technicalQA-tips flex" }, [
                _c("span", [_vm._v("问题回答中，请勿离开当前页面...")]),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            ref: "historyChatContainer",
            staticClass: "chat-scroll",
            on: { scroll: _vm.handleScroll },
          },
          [
            _c(
              "div",
              { staticClass: "chat-content" },
              [
                _c("history-chat-list-comp", {
                  staticClass: "markdown-body",
                  attrs: { "chat-list-data": _vm.chatListData },
                  on: { viewCardData: _vm.viewCardData },
                }),
                !_vm.chatListData.length &&
                !_vm.streamLoading &&
                _vm.searchType === "2"
                  ? _c(
                      "div",
                      [
                        _c("el-empty", {
                          attrs: {
                            description:
                              "因您在生成中离开此页面，导致生成中断，您可以重新发起对话",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.streamLoading
                  ? _c(
                      "div",
                      {
                        ref: "dataContainer",
                        staticClass: "answering markdown-body",
                      },
                      [
                        _c("div", { staticClass: "question-answer" }, [
                          _c("div", { staticClass: "question-item" }, [
                            _c("p", [_vm._v(_vm._s(_vm.currentQuestion))]),
                          ]),
                          _c("div", { staticClass: "answer-item" }, [
                            _c("div", { staticClass: "avatar" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/common/ai-answer.png"),
                                  alt: "",
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "answer-con" }, [
                              _vm.searchType === "1"
                                ? _c(
                                    "div",
                                    [
                                      _vm.processedThinkingHTML.length > 0
                                        ? _c(
                                            "toggle-component",
                                            {
                                              attrs: {
                                                "default-visible": true,
                                              },
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "answer-text thinking-con",
                                                staticStyle: {
                                                  "white-space": "normal",
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.processedThinkingHTML
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("div", {
                                        staticClass: "answer-text",
                                        staticStyle: {
                                          "white-space": "normal",
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.processedResultHTML
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.searchType === "2"
                                ? _c("div", [
                                    _vm.streamLoading
                                      ? _c("div", { staticClass: "flex" }, [
                                          _c("span", [
                                            _vm._v(
                                              "问题回答中，请勿离开当前页面..."
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _c("div", {
                                      staticClass: "answer-con",
                                      staticStyle: {
                                        padding: "0",
                                        "white-space": "pre-wrap",
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(_vm.academicQAData),
                                      },
                                    }),
                                  ])
                                : _c("div", [
                                    _c("div", { staticClass: "answer-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.normalData || "正在思考..."
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                              _vm.streamLoading
                                ? _c("img", {
                                    staticClass: "loading-css",
                                    attrs: {
                                      src: require("@/assets/images/Loading.gif"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "textarea-comp" },
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: "回到底部",
                  placement: "top",
                  transition: "",
                  "popper-class": "hover-popper",
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showScrollToBottomButton,
                        expression: "showScrollToBottomButton",
                      },
                    ],
                    staticClass: "bottom-btn",
                    on: { click: _vm.scrollToBottom },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-arrow-down",
                      staticStyle: { color: "rgb(0, 91, 172)" },
                    }),
                  ]
                ),
              ]
            ),
            _c("textareaComp", {
              attrs: {
                "text-area-width": `800px`,
                "rows-number": 2,
                loading: _vm.streamLoading,
              },
              on: {
                sendQuestion: _vm.handleSendQuestion,
                abortRequest: _vm.handleAbortRequest,
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm.showCard
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.rightCardLoading,
                expression: "rightCardLoading",
              },
            ],
            staticClass: "card-list",
            style: {
              height:
                _vm.$route.name === "scholarSearchHistoryGuoJiao" ||
                _vm.$route.name === "technicalQAHistoryGuoJiao"
                  ? `calc(100vh - 20px)`
                  : `calc(100vh - 100px)`,
            },
          },
          [
            _vm.lastDataType === 2
              ? _c("paper-list-comp", {
                  attrs: { "paper-list-data": _vm.paperCardData },
                })
              : _c("talent-list-comp", {
                  attrs: { "talent-list-data": _vm.scholarCardData },
                }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }